// p-editor-components.js

(() => {
  // namespace
  // ---- Group registry (one source of truth)
  window.MPE = window.MPE || {};
  (() => {
    const M = window.MPE;

    // Static base (back-compat)
    const GROUPS = {
      nummer: { kind: 'text', placeholder: M.PLACEHOLDERS?.nummer || '00' },
      initialen: { kind: 'text', placeholder: M.PLACEHOLDERS?.initialen || 'AB' },
      spielername: { kind: 'text', placeholder: M.PLACEHOLDERS?.spielername || 'NAME' },
      vereinsname: { kind: 'text', placeholder: M.PLACEHOLDERS?.vereinsname || 'VEREIN' },
      text: { kind: 'text', placeholder: 'TEXT' },

      sponsor: { kind: 'file', filesRowKey: 'sponsor', formProp: '_SponsorURL' },
      vereinslogo: { kind: 'file', filesRowKey: 'vereinslogo', formProp: '_VereinslogoURL' },
      logo: { kind: 'file', filesRowKey: 'logo', formProp: '_LogoURL' }
    };

    // ---- helpers for dynamic groups
    const isLogoDyn = (g) => /^logo(?:[\s\-_]*\d+)?$/i.test(String(g || ''));
    const toPascal = (g) => String(g || '')
      .replace(/[^a-z0-9]+/gi, ' ')
      .trim()
      .split(/\s+/)
      .map(w => w ? w[0].toUpperCase() + w.slice(1) : '')
      .join('');
    // e.g. 'logo-2' -> 'logo2', 'vereins-logo' -> 'vereinslogo'
    const toDataKey = (g) => String(g || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

    const dynamicKind = (g) => (isLogoDyn(g) ? 'file' : 'text');
    const dynamicFilesRowKey = (g) => (isLogoDyn(g) ? toDataKey(g) : '');
    const dynamicFormProp = (g) => {
      if (isLogoDyn(g)) {
        const m = String(g).match(/^logo[\s\-_]*([0-9]+)$/i);
        return m ? `_Logo${m[1]}URL` : `_LogoURL`;
      }
      // generic fallback for future file-groups if додаси в DOM без реєстру:
      // return `_${toPascal(g)}URL`;  // лишаємо закоментованим, поки текстові не стають file
      return '';
    };
    const dynamicPlaceholder = (g) => M.PLACEHOLDERS?.[g] || 'TEXT';

    const group = {
      cfg: (g) => GROUPS[g] || null,
      // prefer static config; else derive
      kind: (g) => (GROUPS[g]?.kind) || dynamicKind(g),
      isFile: (g) => (GROUPS[g]?.kind === 'file') || isLogoDyn(g),
      placeholder: (g) => GROUPS[g]?.placeholder || dynamicPlaceholder(g),
      filesRowKey: (g) => GROUPS[g]?.filesRowKey || dynamicFilesRowKey(g),
      formProp: (g) => GROUPS[g]?.formProp || dynamicFormProp(g),
    };

    // expose both registry and helpers
    M.GROUPS = GROUPS;
    M.groups = group;
  })();


  const {
    $, $$, px, sideOf, handleize, parseValue,
    getZoneRect, measureZone, splitToTwoLines, measureMultilineBBox, fitTextToZone,
    PLACEHOLDERS, storage, deps, svg: SVGUtil = {}, preview: PrevUtil = {}
  } = window.MPE;



  // // ---------- <mpe-print-toggle> ----------
  // class MpePrintToggle extends HTMLElement {
  //   connectedCallback() {
  //     this.storageKey = this.dataset.storageKey || 'mpe-print';
  //     this.filesRow = this.querySelector('.mpe-variant-table__files-row') || null;

  //     this._onOptionChange = this._onOptionChange.bind(this);
  //     this._onGroupDisableToggle = this._onGroupDisableToggle.bind(this);
  //     this._onExternalEmit = this._onExternalEmit.bind(this);
  //     this._onResetClick = this._onResetClick.bind(this);

  //     this._init();
  //     this._applySavedState();
  //     document.addEventListener('mpe:zones:request', this._onExternalEmit);
  //   }

  //   disconnectedCallback() {
  //     document.removeEventListener('mpe:zones:request', this._onExternalEmit);
  //     if (this._emitReq) cancelAnimationFrame(this._emitReq);
  //     clearTimeout(this._saveT);
  //     this._teardown();
  //   }
  //   // ---- priority rules for data-radio-group ----
  //   _setPriorityBlockedState(el, blocked) {
  //     el.disabled = !!blocked;
  //     const label = el.closest('label');
  //     if (label) {
  //       label.classList.toggle('p-editor-radio-is-priority-blocked', !!blocked);
  //       if (blocked) {
  //         label.setAttribute('aria-disabled', 'true');
  //         if (!label.title) label.title = 'Blocked by priority';
  //       } else {
  //         label.removeAttribute('aria-disabled');
  //         if (label.title === 'Blocked by priority') label.removeAttribute('title');
  //       }
  //     }
  //   }

  //   _enforcePriorityRules() {
  //     const all = Array.from(this.printRadiosRoot.querySelectorAll('input[data-radio-group]'))
  //       .filter(el => el && (el.type === 'checkbox' || el.type === 'radio'));
  //     if (!all.length) return;

  //     const isPriority = (el) => String(el.dataset.radioPriority).toLowerCase() === 'true';

  //     // reset all states first
  //     all.forEach(el => this._setPriorityBlockedState(el, false));

  //     const anyPriorityChecked = all.some(el => isPriority(el) && el.checked);
  //     const anyNormalChecked = all.some(el => !isPriority(el) && el.checked);
  //     let changed = false;

  //     // if any priority is checked -> block all non-priority
  //     if (anyPriorityChecked) {
  //       all.forEach(el => {
  //         if (!isPriority(el)) {
  //           if (el.checked) { el.checked = false; changed = true; }
  //           this._setPriorityBlockedState(el, true);
  //         }
  //       });
  //     }

  //     // if any non-priority is checked -> block all priority
  //     else if (anyNormalChecked) {
  //       all.forEach(el => {
  //         if (isPriority(el)) {
  //           if (el.checked) { el.checked = false; changed = true; }
  //           this._setPriorityBlockedState(el, true);
  //         }
  //       });
  //     }

  //     if (changed) this._scheduleEmit();
  //   }




  //   reinitialize() {
  //     this._init();
  //     this._applySavedState();
  //   }

  //   _init() {
  //     this._teardown();
  //     this.printRadiosRoot = this.querySelector('.print-radios') || this;
  //     this.options = Array.from(this.printRadiosRoot.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
  //     this.groups = {};
  //     for (let i = 0; i < this.options.length; i++) {
  //       const el = this.options[i];
  //       const g = (el.dataset.radioGroup || parseValue(el.value).group || '').trim();
  //       if (!g) continue;
  //       (this.groups[g] || (this.groups[g] = [])).push(el);
  //     }
  //     this.groupToggles = Array.from(this.querySelectorAll('.group-disable-toggle'));
  //     this.groupToggles.forEach(t => t.addEventListener('change', this._onGroupDisableToggle));
  //     this.options.forEach(o => o.addEventListener('change', this._onOptionChange));

  //     // file-методи
  //     this._bindFileInputs();
  //     this._prefillFilePreviewsFromGlobals();

  //     Object.keys(this.groups).forEach(g => this._applyGroup(g));
  //     this._enforceZoneExclusivity();
  //     this._enforcePriorityRules(); // ensure priority from the start

  //     this._onRadiosRootChange = () => this._scheduleEmit();
  //     this.printRadiosRoot.addEventListener('change', this._onRadiosRootChange);

  //     this._bindResetButtons();
  //   }

  //   _teardown() {
  //     if (this.options) this.options.forEach(o => o.removeEventListener('change', this._onOptionChange));
  //     if (this.groupToggles) this.groupToggles.forEach(t => t.removeEventListener('change', this._onGroupDisableToggle));
  //     if (this.printRadiosRoot && this._onRadiosRootChange)
  //       this.printRadiosRoot.removeEventListener('change', this._onRadiosRootChange);
  //     if (this._resetBtns) this._resetBtns.forEach(b => b.removeEventListener('click', this._onResetClick));
  //     this._resetBtns = [];
  //   }

  //   // emit coalescing
  //   _scheduleEmit() {
  //     if (this._emitReq) return;
  //     this._emitReq = requestAnimationFrame(() => {
  //       this._emitReq = 0;
  //       this._emitZonesContentNow();
  //     });
  //   }

  //   // handlers
  //   _onOptionChange(e) {
  //     const group = (e.target.dataset.radioGroup || parseValue(e.target.value).group || '').trim();
  //     if (this._isGroupDisabled(group)) return;
  //     this._applyGroup(group);
  //     this._enforceZoneExclusivity();
  //     this._enforcePriorityRules();
  //     this._saveState();
  //     this._scheduleEmit();
  //   }

  //   _onGroupDisableToggle(e) {
  //     const group = e.target.dataset.group; const disabled = !!e.target.checked;
  //     this._setGroupDisabled(group, disabled);
  //     this._enforceZoneExclusivity();
  //     this._saveState();
  //     this._scheduleEmit();
  //   }

  //   // реагує і на зовнішні mpe:zones:request
  //   _onExternalEmit(e) {
  //     if (!e || !e.target || !this.contains(e.target)) this._scheduleEmit();
  //   }

  //   _bindResetButtons() {
  //     this._resetBtns = Array.from(this.querySelectorAll('.print-radios__group [data-action="reset-selection"]'));
  //     this._resetBtns.forEach(btn => btn.addEventListener('click', this._onResetClick));
  //   }

  //   _onResetClick(e) {
  //     e.preventDefault();
  //     this.options.forEach(o => { o.checked = false; o.disabled = false; o.classList.remove('p-editor-radio-is-conflict'); });
  //     this.querySelectorAll('.p-editor-radio-is-conflict').forEach(el => el.classList.remove('p-editor-radio-is-conflict'));
  //     Object.keys(this.groups).forEach(group => {
  //       this.querySelectorAll('.mpe-variant-table__cell[data-group="' + group + '"]').forEach(el => {
  //         el.classList.remove('is-visible'); el.classList.add('is-hidden');
  //       });
  //     });
  //     this._enforceZoneExclusivity();
  //     this._enforcePriorityRules();
  //     this._saveState();
  //     this._scheduleEmit();
  //   }

  //   // table visibility
  //   _setGroupDisabled(group, disabled) {
  //     const fs = this.querySelector('.print-radios__group[data-group="' + group + '"]');
  //     if (fs) fs.classList.toggle('group-is-disabled', disabled);

  //     this.querySelectorAll('.mpe-variant-table__cell[data-group="' + group + '"]').forEach(el => {
  //       if (disabled) {
  //         el.classList.add('is-hidden'); el.classList.remove('is-visible');
  //         el.querySelectorAll('input,select,textarea,button').forEach(i => i.disabled = true);
  //       } else {
  //         el.querySelectorAll('input,select,textarea,button').forEach(i => i.disabled = false);
  //       }
  //     });

  //     if (!disabled) this._applyGroup(group);
  //   }

  //   _isGroupDisabled(group) {
  //     const fs = this.querySelector('.print-radios__group[data-group="' + group + '"]');
  //     return !!(fs && fs.classList.contains('group-is-disabled'));
  //   }

  //   _applyGroup(group) {
  //     this.querySelectorAll('.mpe-variant-table__cell[data-group="' + group + '"]')
  //       .forEach(el => { el.classList.remove('is-visible'); el.classList.add('is-hidden'); });

  //     if (this._isGroupDisabled(group)) return;
  //     const opts = this.groups[group] || [];
  //     const checkedList = opts.filter(o => o.checked);
  //     if (!checkedList.length) return;

  //     const singletonCells = this.querySelectorAll('.mpe-variant-table__cell[data-group="' + group + '"][data-any="true"]');
  //     if (singletonCells.length) {
  //       singletonCells.forEach(el => { el.classList.remove('is-hidden'); el.classList.add('is-visible'); });
  //       return;
  //     }
  //     checkedList.forEach(ch => {
  //       const z = (ch.dataset.radioZone || parseValue(ch.value).zone || '').trim();
  //       const key = group + '-' + z;
  //       this.querySelectorAll('.mpe-variant-table__cell[data-key="' + key + '"]')
  //         .forEach(el => { el.classList.remove('is-hidden'); el.classList.add('is-visible'); });
  //     });
  //   }

  //   // exclusivity
  //   _setConflictState(rb, isConflict) {
  //     rb.disabled = !!isConflict;
  //     rb.classList.toggle('p-editor-radio-is-conflict', !!isConflict);
  //     const label = rb.closest('label');
  //     if (label) {
  //       label.classList.toggle('p-editor-radio-is-conflict', !!isConflict);
  //       if (isConflict) {
  //         label.setAttribute('aria-disabled', 'true');
  //         label.title = 'Zone already used in another group';
  //       } else {
  //         label.removeAttribute('aria-disabled');
  //         label.removeAttribute('title');
  //       }
  //     }
  //   }

  //   _enforceZoneExclusivity() {
  //     this.options.forEach(o => this._setConflictState(o, false));
  //     const groupEls = Array.from(this.printRadiosRoot.querySelectorAll('.print-radios__group[data-group]'));
  //     const domGroups = groupEls.map(el => el.getAttribute('data-group')).filter(Boolean);
  //     const taken = new Map();

  //     domGroups.forEach(group => {
  //       if (!this.groups[group] || this._isGroupDisabled(group)) return;
  //       this.groups[group].filter(r => r.checked).forEach(r => {
  //         const z = (r.dataset.radioZone || parseValue(r.value).zone || '');
  //         if (!z) return;
  //         const owner = taken.get(z);
  //         if (owner && owner !== group) r.checked = false; else taken.set(z, group);
  //       });
  //     });

  //     domGroups.forEach(group => {
  //       if (!this.groups[group] || this._isGroupDisabled(group)) return;
  //       this.groups[group].forEach(rb => {
  //         const z = (rb.dataset.radioZone || parseValue(rb.value).zone) || '';
  //         if (!z) return;
  //         const owner = taken.get(z);
  //         this._setConflictState(rb, !!(owner && owner !== group));
  //       });
  //     });
  //     this._enforcePriorityRules();
  //   }

  //   // state
  //   _readState() { try { return JSON.parse(localStorage.getItem(this.storageKey) || '{}'); } catch (e) { return {}; } }

  //   _saveState() {
  //     clearTimeout(this._saveT);
  //     this._saveT = setTimeout(() => {
  //       if (!this.groups) return;
  //       const state = this._readState();
  //       state.selection = {};
  //       Object.keys(this.groups).forEach(g => {
  //         const keys = this.groups[g].filter(r => r.checked).map(r => parseValue(r.value).key);
  //         if (keys.length) state.selection[g] = keys;
  //       });
  //       // ⛔ більше не зберігаємо disabledGroups
  //       try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch (_) {}
  //     }, 0);
  //   }


  //     _applySavedState() {
  //       const state = this._readState();

  //       // 🔥 одноразова «міграція»: прибрати застарілий запис і перезаписати
  //       if (state && state.disabledGroups) {
  //         delete state.disabledGroups;
  //         try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch (_) {}
  //       }

  //       // завжди стартуємо з увімкненими групами
  //       (this.groupToggles || []).forEach(tg => {
  //         tg.checked = false;
  //         this._setGroupDisabled(tg.dataset.group, false);
  //       });

  //       if (state.selection && this.groups) {
  //         Object.keys(this.groups).forEach(group => {
  //           const wanted = state.selection[group] || [];
  //           this.groups[group].forEach(r => {
  //             if (wanted.includes(parseValue(r.value).key)) r.checked = true;
  //           });
  //           this._applyGroup(group);
  //         });
  //       } else {
  //         Object.keys(this.groups || {}).forEach(g => this._applyGroup(g));
  //       }

  //       this._enforceZoneExclusivity();
  //       this._enforcePriorityRules();
  //     }


  //   // ---------- files previews/helpers ----------
  //   _getGlobalFileUrl(group) {
  //     const r = this.filesRow; if (!r) return '';
  //     const key = window.MPE.groups.filesRowKey(group); if (!key) return '';
  //     return r.dataset[`${key}Url`] || '';
  //   }

  //   _getGlobalFileName(group) {
  //     const r = this.filesRow; if (!r) return '';
  //     const key = window.MPE.groups.filesRowKey(group); if (!key) return '';
  //     return r.dataset[`${key}Name`] || '';
  //   }

  //   _setGlobalFile(group, obj) {
  //     const r = this.filesRow; if (!r) return;
  //     const key = window.MPE.groups.filesRowKey(group); if (!key) return;
  //     const url = (obj && obj.url) || '', name = (obj && obj.name) || '';
  //     if (url) r.dataset[`${key}Url`] = url;
  //     if (name) r.dataset[`${key}Name`] = name;
  //   }

  //   _bindFileInputs() {
  //     const self = this;
  //     this.querySelectorAll('input[type="file"][data-file]').forEach(input => {
  //       const group = (input.dataset.inputGroup || '').trim();
  //       const label = input.closest('label');
  //       const nameEl = label ? label.querySelector('.mpe-file-name') : null;
  //       const previewEl = label ? label.querySelector('.mpe-file-preview') : null;
  //       let lastUrl = '';

  //       function onChange() {
  //         const file = input.files && input.files[0];
  //         delete input.dataset.previewUrl; delete input.dataset.objectName;
  //         if (lastUrl) { try { URL.revokeObjectURL(lastUrl); } catch (e) { } lastUrl = ''; }

  //         if (!file) {
  //           if (nameEl) nameEl.textContent = '';
  //           if (previewEl) { previewEl.style.display = 'none'; previewEl.src = ''; }
  //           return;
  //         }
  //         if (file.type.indexOf('image/') !== 0) {
  //           if (nameEl) nameEl.textContent = file.name + ' (unsupported)';
  //           if (previewEl) { previewEl.style.display = 'none'; previewEl.src = ''; }
  //           return;
  //         }
  //         let url = ''; try { url = URL.createObjectURL(file); } catch (e) { url = ''; }
  //         input.dataset.previewUrl = url; input.dataset.objectName = file.name; lastUrl = url;

  //         if (group && url) self._setGlobalFile(group, { url: url, name: file.name });
  //         if (nameEl) nameEl.textContent = file.name;
  //         if (previewEl) { previewEl.src = url; previewEl.style.display = 'inline-block'; }
  //       }
  //       input.addEventListener('change', onChange, { passive: true });
  //     });
  //   }

  //   _prefillFilePreviewsFromGlobals() {
  //     const inputs = Array.from(this.querySelectorAll('input[type="file"][data-file]'));
  //     inputs.forEach(input => {
  //       const group = (input.dataset.inputGroup || '').trim(); if (!group) return;
  //       const url = this._getGlobalFileUrl(group); const name = this._getGlobalFileName(group); if (!url) return;
  //       input.dataset.previewUrl = url; if (name) input.dataset.objectName = name;
  //       const label = input.closest('label'); const nameEl = label ? label.querySelector('.mpe-file-name') : null; const previewEl = label ? label.querySelector('.mpe-file-preview') : null;
  //       if (nameEl && name) nameEl.textContent = name;
  //       if (previewEl) { previewEl.src = url; previewEl.style.display = 'inline-block'; }
  //     });
  //   }

  //   // ---------- emit (із унікальним ключем включно з row_key) ----------
  //   _emitZonesContentNow() {
  //     const inputs = []; const seen = new Set();

  //     // активні зони для кожної групи
  //     const activeZoneByGroup = {};
  //     Object.keys(this.groups || {}).forEach(group => {
  //       const list = this.groups[group].filter(r => r.checked);
  //       if (list.length && !this._isGroupDisabled(group)) {
  //         const set = new Set();
  //         list.forEach(r => {
  //           const z = (r.dataset.radioZone || parseValue(r.value).zone || '').trim();
  //           if (z) set.add(z);
  //         });
  //         if (set.size) activeZoneByGroup[group] = set;
  //       }
  //     });


  //     const push = (obj) => {
  //       if (!obj || !obj.group || !obj.zone) return;
  //       const key = `${obj.row_key || 'r0'}:${obj.group}:${obj.zone}:${obj.type}`;
  //       if (seen.has(key)) return; seen.add(key); inputs.push(obj);
  //     };

  //     // збір із mpe-variant-table
  //     const rows = Array.from(this.querySelectorAll('.mpe-variant-table__row[data-row-index]'));
  //     rows.forEach(row => {
  //       const row_key = row.getAttribute('data-key') || '';
  //       row.querySelectorAll('.mpe-variant-table__cell.is-visible [data-input-group]')
  //         .forEach(el => {
  //           const group = (el.dataset.inputGroup || '').trim();
  //           if (!group || this._isGroupDisabled(group)) return;

  //           // зони: або явна, або всі активні групи
  //           let zonesToPush = [];
  //           const zone = (el.dataset.zone || '').trim();
  //           if (zone) zonesToPush = [zone];
  //           else {
  //             const set = activeZoneByGroup[group];
  //             if (set && set.size) zonesToPush = Array.from(set);
  //           }
  //           if (!zonesToPush.length) return;

  //           const tag = el.tagName.toLowerCase();
  //           const type = (tag === 'textarea') ? 'textarea' : (el.type || '').toLowerCase();
  //           if (type === 'hidden') return;

  //           zonesToPush.forEach(zx => {
  //             if (type === 'file') {
  //               const value = el.dataset.objectName || (el.files && el.files[0] && el.files[0].name) || '';
  //               const url = el.dataset.previewUrl || this._getGlobalFileUrl(group) || '';
  //               push({ row_key, group, zone: zx, value, type: 'file', url });
  //             } else if (type === 'checkbox') {
  //               push({ row_key, group, zone: zx, value: (el.checked ? '✓' : ''), type: 'checkbox' });
  //             } else {
  //               const valueT = (el.value || '').trim();
  //               push({ row_key, group, zone: zx, value: valueT, type: (type === 'textarea' ? 'text' : type) });
  //             }
  //           });
  //         });
  //     });

  //     // збір із mpe-variant-table__files-row
  //     const filesRow = this.querySelector('.mpe-variant-table__files-row');
  //     if (filesRow) {
  //       const row_key = filesRow.getAttribute('data-key') || '';
  //       filesRow.querySelectorAll('.mpe-variant-table__cell.is-visible [data-input-group]')
  //         .forEach(el => {
  //           const group = (el.dataset.inputGroup || '').trim();
  //           if (!group || this._isGroupDisabled(group)) return;

  //           const set = activeZoneByGroup[group];
  //           const zonesToPush = (el.dataset.zone || '').trim()
  //             ? [el.dataset.zone.trim()]
  //             : (set && set.size ? Array.from(set) : []);
  //           if (!zonesToPush.length) return;

  //           const tag = el.tagName.toLowerCase();
  //           const type = (tag === 'textarea') ? 'textarea' : (el.type || '').toLowerCase();
  //           if (type === 'hidden') return;

  //           zonesToPush.forEach(zx => {
  //             if (type === 'file') {
  //               const value = el.dataset.objectName || (el.files && el.files[0] && el.files[0].name) || '';
  //               const url = el.dataset.previewUrl || this._getGlobalFileUrl(group) || '';
  //               push({ row_key, group, zone: zx, value, type: 'file', url });
  //             } else if (type === 'checkbox') {
  //               push({ row_key, group, zone: zx, value: (el.checked ? '✓' : ''), type: 'checkbox' });
  //             } else {
  //               const valueT = (el.value || '').trim();
  //               push({ row_key, group, zone: zx, value: valueT, type: (type === 'textarea' ? 'text' : type) });
  //             }
  //           });
  //         });
  //     }

  //     document.dispatchEvent(new CustomEvent('mpe:zones:content', { detail: { inputs }, bubbles: true, composed: true }));
  //   }

  //   _selectedGroups(activeByGroup) {
  //     return Array.from(activeByGroup.keys());
  //   }

  //   _appendFileProp(fd, idx, group, scope) {
  //     const prop = window.MPE.groups.formProp(group);
  //     if (!prop) return;
  //     const f = this._pickFileByGroup(scope, group);
  //     const url = this._pickUrlByGroup(scope, group) || 'empty';
  //     if (f) fd.append(`items[${idx}][properties][${prop}]`, f, f.name);
  //     else fd.append(`items[${idx}][properties][${prop}]`, url);
  //   }

  //   _collectTextValue(scope, group) {
  //     return this._pickTextByGroup(scope, group) || '';
  //   }

  //   // ---------- local DOM pickers (узгоджено з emitter) ----------
  //   _isHttpUrl(v) { return !!(v && /^https?:\/\//i.test(String(v).trim())); }

  //   _pickFileByGroup(scope, group) {
  //     const vis = `.mpe-variant-table__files-row .mpe-variant-table__cell.is-visible input[type="file"][data-input-group="${group}"]`;
  //     const any = `input[type="file"][data-input-group="${group}"]`;
  //     const input = scope.querySelector(vis) || scope.querySelector(any);
  //     if (!input) return null;
  //     return (input.files && input.files.length) ? input.files[0] : null;
  //   }

  //   _pickUrlByGroup(scope, group) {
  //     const cellSel = `.mpe-variant-table__files-row .mpe-variant-table__cell.is-visible`;
  //     const filesRowEl = scope.querySelector('.mpe-variant-table__files-row') || null;

  //     // 1) видимий text/url/textarea інпут
  //     const visInput = scope.querySelector(
  //       `${cellSel} [data-input-group="${group}"]`
  //     );
  //     if (visInput) {
  //       const dpu = visInput.dataset?.previewUrl || '';
  //       if (this._isHttpUrl(dpu)) return dpu;

  //       const val = (visInput.value || '').trim();
  //       if (this._isHttpUrl(val)) return val;
  //     }

  //     // 2) видимий <input type="file">
  //     const fileVisible = scope.querySelector(
  //       `${cellSel} input[type="file"][data-input-group="${group}"]`
  //     );
  //     if (fileVisible) {
  //       const dpu = fileVisible.dataset?.previewUrl || '';
  //       if (this._isHttpUrl(dpu)) return dpu;
  //       const val = (fileVisible.value || '').trim();
  //       if (this._isHttpUrl(val)) return val;
  //     }

  //     // 3) фолбек з files-row (через реєстр груп)
  //     const key = window.MPE.groups.filesRowKey(group);
  //     if (filesRowEl && key) {
  //       const fromRow = filesRowEl.dataset[`${key}Url`] || '';
  //       if (this._isHttpUrl(fromRow)) return fromRow;
  //     }
  //     return '';
  //   }

  //   _pickTextByGroup(scope, group) {
  //     const sel = `.mpe-variant-table__cell.is-visible [data-input-group="${group}"]`;
  //     const el = scope.querySelector(sel);
  //     if (!el) return '';
  //     if (el.tagName.toLowerCase() === 'textarea') return (el.value || '').trim();
  //     const type = (el.type || '').toLowerCase();
  //     if (['text', 'search', 'tel', 'email', 'url'].includes(type)) return (el.value || '').trim();
  //     return (el.value || '').trim();
  //   }
  // }


  // if (!customElements.get('mpe-print-toggle')) customElements.define('mpe-print-toggle', MpePrintToggle);

  // document.addEventListener('shopify:section:load', e => {
  //   e.target.querySelectorAll('mpe-print-toggle').forEach(el => { if (el && typeof el.reinitialize === 'function') el.reinitialize(); });
  // });
// ---------- <mpe-print-toggle> ----------
class MpePrintToggle extends HTMLElement {
  connectedCallback() {
    this.storageKey = this.dataset.storageKey || 'mpe-print';
    this.filesRow = this.querySelector('.mpe-variant-table__files-row') || null;

    this._onOptionChange = this._onOptionChange.bind(this);
    this._onGroupDisableToggle = this._onGroupDisableToggle.bind(this);
    this._onExternalEmit = this._onExternalEmit.bind(this);
    this._onResetClick = this._onResetClick.bind(this);

    this._init();
    // this._applySavedState();
    this._initFirstFree();

    document.addEventListener('mpe:zones:request', this._onExternalEmit);
  }

  disconnectedCallback() {
    document.removeEventListener('mpe:zones:request', this._onExternalEmit);
    if (this._emitReq) cancelAnimationFrame(this._emitReq);
    clearTimeout(this._saveT);
    this._teardown();
  }

  // ---- priority rules for data-radio-group ----
  _setPriorityBlockedState(el, blocked) {
    el.disabled = !!blocked;
    const label = el.closest('label');
    if (label) {
      label.classList.toggle('p-editor-radio-is-priority-blocked', !!blocked);
      if (blocked) {
        label.setAttribute('aria-disabled', 'true');
        if (!label.title) label.title = 'Blocked by priority';
      } else {
        label.removeAttribute('aria-disabled');
        if (label.title === 'Blocked by priority') label.removeAttribute('title');
      }
    }
  }

  _enforcePriorityRules() {
    const all = Array.from(
      this.printRadiosRoot.querySelectorAll('input[data-radio-group]')
    ).filter(el => el && (el.type === 'checkbox' || el.type === 'radio'));
    if (!all.length) return;

    const isPriority = (el) =>
      String(el.dataset.radioPriority).toLowerCase() === 'true';

    // reset all states first
    all.forEach(el => this._setPriorityBlockedState(el, false));

    const anyPriorityChecked = all.some(el => isPriority(el) && el.checked);
    const anyNormalChecked = all.some(el => !isPriority(el) && el.checked);
    let changed = false;

    // if any priority is checked -> block all non-priority
    if (anyPriorityChecked) {
      all.forEach(el => {
        if (!isPriority(el)) {
          if (el.checked) {
            el.checked = false;
            changed = true;
          }
          this._setPriorityBlockedState(el, true);
        }
      });
    }

    // if any non-priority is checked -> block all priority
    else if (anyNormalChecked) {
      all.forEach(el => {
        if (isPriority(el)) {
          if (el.checked) {
            el.checked = false;
            changed = true;
          }
          this._setPriorityBlockedState(el, true);
        }
      });
    }

    if (changed) this._scheduleEmit();
  }

  reinitialize() {
    this._init();
    // this._applySavedState();
    this._initFirstFree();
  }

  _init() {
    this._teardown();
    this.printRadiosRoot = this.querySelector('.print-radios') || this;
    this.options = Array.from(
      this.printRadiosRoot.querySelectorAll('input[type="radio"], input[type="checkbox"]')
    );
    this.groups = {};
    for (let i = 0; i < this.options.length; i++) {
      const el = this.options[i];
      const g = (el.dataset.radioGroup || parseValue(el.value).group || '').trim();
      if (!g) continue;
      (this.groups[g] || (this.groups[g] = [])).push(el);
    }
    this.groupToggles = Array.from(this.querySelectorAll('.group-disable-toggle'));
    this.groupToggles.forEach(t =>
      t.addEventListener('change', this._onGroupDisableToggle)
    );
    this.options.forEach(o => o.addEventListener('change', this._onOptionChange));

    // file-методи
    this._bindFileInputs();
    this._prefillFilePreviewsFromGlobals();

    Object.keys(this.groups).forEach(g => this._applyGroup(g));
    this._enforceZoneExclusivity();
    this._enforcePriorityRules(); // ensure priority from the start

    this._onRadiosRootChange = () => this._scheduleEmit();
    this.printRadiosRoot.addEventListener('change', this._onRadiosRootChange);

    this._bindResetButtons();
  }

  _teardown() {
    if (this.options)
      this.options.forEach(o =>
        o.removeEventListener('change', this._onOptionChange)
      );
    if (this.groupToggles)
      this.groupToggles.forEach(t =>
        t.removeEventListener('change', this._onGroupDisableToggle)
      );
    if (this.printRadiosRoot && this._onRadiosRootChange)
      this.printRadiosRoot.removeEventListener('change', this._onRadiosRootChange);
    if (this._resetBtns)
      this._resetBtns.forEach(b =>
        b.removeEventListener('click', this._onResetClick)
      );
    this._resetBtns = [];

    // зняти лістенери з free-input’ів
    if (this._freeLabels && this._onFreeChangeBound) {
      this._freeLabels.forEach(label => {
        const input = label.querySelector(
          'input[type="checkbox"], input[type="radio"]'
        );
        if (input) {
          input.removeEventListener('change', this._onFreeChangeBound);
        }
      });
    }
    this._freeLabels = null;
    this._paidLabels = null;
  }

  // emit coalescing
  _scheduleEmit() {
    if (this._emitReq) return;
    this._emitReq = requestAnimationFrame(() => {
      this._emitReq = 0;
      this._emitZonesContentNow();
    });
  }

  // handlers
  _onOptionChange(e) {
    const group = (
      e.target.dataset.radioGroup || parseValue(e.target.value).group || ''
    ).trim();
    if (this._isGroupDisabled(group)) return;
    this._applyGroup(group);
    this._enforceZoneExclusivity();
    this._enforcePriorityRules();
    // this._saveState();
    this._scheduleEmit();
  }

  _onGroupDisableToggle(e) {
    const group = e.target.dataset.group;
    const disabled = !!e.target.checked;
    this._setGroupDisabled(group, disabled);
    this._enforceZoneExclusivity();
    // this._saveState();
    this._scheduleEmit();
  }

  // реагує і на зовнішні mpe:zones:request
  _onExternalEmit(e) {
    if (!e || !e.target || !this.contains(e.target)) this._scheduleEmit();
  }

  _bindResetButtons() {
    this._resetBtns = Array.from(
      this.querySelectorAll('.print-radios__group [data-action="reset-selection"]')
    );
    this._resetBtns.forEach(btn =>
      btn.addEventListener('click', this._onResetClick)
    );
  }

  _onResetClick(e) {
    e.preventDefault();
    this.options.forEach(o => {
      o.checked = false;
      o.disabled = false;
      o.classList.remove('p-editor-radio-is-conflict');
    });
    this.querySelectorAll('.p-editor-radio-is-conflict').forEach(el =>
      el.classList.remove('p-editor-radio-is-conflict')
    );
    Object.keys(this.groups).forEach(group => {
      this.querySelectorAll(
        '.mpe-variant-table__cell[data-group="' + group + '"]'
      ).forEach(el => {
        el.classList.remove('is-visible');
        el.classList.add('is-hidden');
      });
    });
    this._enforceZoneExclusivity();
    this._enforcePriorityRules();
    // this._saveState();
    this._scheduleEmit();

    // після reset → повертаємось у режим "тільки free"
    this._showFreeOnly();
  }

  // table visibility
  _setGroupDisabled(group, disabled) {
    const fs = this.querySelector(
      '.print-radios__group[data-group="' + group + '"]'
    );
    if (fs) fs.classList.toggle('group-is-disabled', disabled);

    this.querySelectorAll(
      '.mpe-variant-table__cell[data-group="' + group + '"]'
    ).forEach(el => {
      if (disabled) {
        el.classList.add('is-hidden');
        el.classList.remove('is-visible');
        el
          .querySelectorAll('input,select,textarea,button')
          .forEach(i => (i.disabled = true));
      } else {
        el
          .querySelectorAll('input,select,textarea,button')
          .forEach(i => (i.disabled = false));
      }
    });

    if (!disabled) this._applyGroup(group);
  }

  _isGroupDisabled(group) {
    const fs = this.querySelector(
      '.print-radios__group[data-group="' + group + '"]'
    );
    return !!(fs && fs.classList.contains('group-is-disabled'));
  }

  _applyGroup(group) {
    this.querySelectorAll(
      '.mpe-variant-table__cell[data-group="' + group + '"]'
    ).forEach(el => {
      el.classList.remove('is-visible');
      el.classList.add('is-hidden');
    });

    if (this._isGroupDisabled(group)) return;
    const opts = this.groups[group] || [];
    const checkedList = opts.filter(o => o.checked);
    if (!checkedList.length) return;

    const singletonCells = this.querySelectorAll(
      '.mpe-variant-table__cell[data-group="' + group + '"][data-any="true"]'
    );
    if (singletonCells.length) {
      singletonCells.forEach(el => {
        el.classList.remove('is-hidden');
        el.classList.add('is-visible');
      });
      return;
    }
    checkedList.forEach(ch => {
      const z = (ch.dataset.radioZone || parseValue(ch.value).zone || '').trim();
      const key = group + '-' + z;
      this.querySelectorAll('.mpe-variant-table__cell[data-key="' + key + '"]')
        .forEach(el => {
          el.classList.remove('is-hidden');
          el.classList.add('is-visible');
        });
    });
  }

  // exclusivity
  _setConflictState(rb, isConflict) {
    rb.disabled = !!isConflict;
    rb.classList.toggle('p-editor-radio-is-conflict', !!isConflict);
    const label = rb.closest('label');
    if (label) {
      label.classList.toggle('p-editor-radio-is-conflict', !!isConflict);
      if (isConflict) {
        label.setAttribute('aria-disabled', 'true');
        label.title = 'Zone already used in another group';
      } else {
        label.removeAttribute('aria-disabled');
        label.removeAttribute('title');
      }
    }
  }

  _enforceZoneExclusivity() {
    this.options.forEach(o => this._setConflictState(o, false));
    const groupEls = Array.from(
      this.printRadiosRoot.querySelectorAll('.print-radios__group[data-group]')
    );
    const domGroups = groupEls
      .map(el => el.getAttribute('data-group'))
      .filter(Boolean);
    const taken = new Map();

    domGroups.forEach(group => {
      if (!this.groups[group] || this._isGroupDisabled(group)) return;
      this.groups[group]
        .filter(r => r.checked)
        .forEach(r => {
          const z = (r.dataset.radioZone || parseValue(r.value).zone || '');
          if (!z) return;
          const owner = taken.get(z);
          if (owner && owner !== group) r.checked = false;
          else taken.set(z, group);
        });
    });

    domGroups.forEach(group => {
      if (!this.groups[group] || this._isGroupDisabled(group)) return;
      this.groups[group].forEach(rb => {
        const z = (rb.dataset.radioZone || parseValue(rb.value).zone) || '';
        if (!z) return;
        const owner = taken.get(z);
        this._setConflictState(rb, !!(owner && owner !== group));
      });
    });
    this._enforcePriorityRules();
  }

  // state
  _readState() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    } catch (e) {
      return {};
    }
  }

  _saveState() {
    clearTimeout(this._saveT);
    this._saveT = setTimeout(() => {
      if (!this.groups) return;
      const state = this._readState();
      state.selection = {};
      Object.keys(this.groups).forEach(g => {
        const keys = this.groups[g]
          .filter(r => r.checked)
          .map(r => parseValue(r.value).key);
        if (keys.length) state.selection[g] = keys;
      });
      // ⛔ не зберігаємо disabledGroups
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch (_) {}
    }, 0);
  }

  _applySavedState() {
    const state = this._readState();

    // одноразова «міграція»: прибрати застарілий disabledGroups
    if (state && state.disabledGroups) {
      delete state.disabledGroups;
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch (_) {}
    }

    // завжди стартуємо з увімкненими групами
    (this.groupToggles || []).forEach(tg => {
      tg.checked = false;
      this._setGroupDisabled(tg.dataset.group, false);
    });

    if (state.selection && this.groups) {
      Object.keys(this.groups).forEach(group => {
        const wanted = state.selection[group] || [];
        this.groups[group].forEach(r => {
          if (wanted.includes(parseValue(r.value).key)) r.checked = true;
        });
        this._applyGroup(group);
      });
    } else {
      Object.keys(this.groups || {}).forEach(g => this._applyGroup(g));
    }

    this._enforceZoneExclusivity();
    this._enforcePriorityRules();
  }

  // ---------- FIRST FREE LOGIC ----------
  _initFirstFree() {
    const root = this.printRadiosRoot || this;

    this._paidLabels = Array.from(
      root.querySelectorAll('.print-radios__item-pay')
    );
    this._freeLabels = Array.from(
      root.querySelectorAll('.print-radios__item-free')
    );

    if (!this._freeLabels.length) return;

    if (!this._onFreeChangeBound) {
      this._onFreeChangeBound = this._onFreeChange.bind(this);
    }

    this._freeLabels.forEach(label => {
      const input = label.querySelector(
        'input[type="checkbox"], input[type="radio"]'
      );
      if (input) {
        input.addEventListener('change', this._onFreeChangeBound);
      }
    });

    // початковий стан
    this._showFreeOnly();
  }

  _showFreeOnly() {
    if (!this._freeLabels || !this._freeLabels.length) return;
    const root = this.printRadiosRoot || this;

    // 1) ховаємо всі платні
    (this._paidLabels || []).forEach(label => {
      label.classList.add('visually-hidden');
    });

    // 2) показуємо всі безкоштовні
    this._freeLabels.forEach(label => {
      label.classList.remove('visually-hidden');
    });

    // 3) якщо нічого не вибрано — автосheck першого free, якщо він один
    const anyChecked = root.querySelector(
      '.print-radios input[type="checkbox"]:checked, .print-radios input[type="radio"]:checked'
    );

    if (!anyChecked && this._freeLabels.length === 1) {
      const firstFreeInput = this._freeLabels[0].querySelector(
        'input[type="checkbox"], input[type="radio"]'
      );
      if (firstFreeInput && !firstFreeInput.checked) {
        firstFreeInput.checked = true;
        firstFreeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  _onFreeChange(event) {
    const input = event.target;
    if (
      !input.matches(
        '.print-radios__item-free input[type="checkbox"], .print-radios__item-free input[type="radio"]'
      )
    ) {
      return;
    }

    const label = input.closest('.print-radios__item-free');
    const groupFieldset = input.closest('.print-radios__group');
    if (!label || !groupFieldset) return;

    if (input.checked) {
      // --- ВИБРАНО безкоштовну зону ---

      // 1) показуємо всі платні айтеми глобально
      (this._paidLabels || []).forEach(l => {
        l.classList.remove('visually-hidden');
      });

      // 2) у цій групі платні зони ховаємо
      Array.from(
        groupFieldset.querySelectorAll('.print-radios__item-pay')
      ).forEach(l => {
        l.classList.add('visually-hidden');
      });

      // 3) всі free-лейбли ховаємо, крім поточного
      this._freeLabels.forEach(l => {
        if (l === label) {
          l.classList.remove('visually-hidden');
        } else {
          l.classList.add('visually-hidden');
        }
      });
    } else {
      // --- UNCHECK free → режим "тільки free" ---

      // 1) скидаємо всі платні інпути
      (this._paidLabels || []).forEach(lbl => {
        const inp = lbl.querySelector(
          'input[type="checkbox"], input[type="radio"]'
        );
        if (inp && inp.checked) {
          inp.checked = false;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // 2) знову показуємо тільки free
      this._showFreeOnly();
    }
  }

  // ---------- files previews/helpers ----------
  _getGlobalFileUrl(group) {
    const r = this.filesRow;
    if (!r) return '';
    const key = window.MPE.groups.filesRowKey(group);
    if (!key) return '';
    return r.dataset[`${key}Url`] || '';
  }

  _getGlobalFileName(group) {
    const r = this.filesRow;
    if (!r) return '';
    const key = window.MPE.groups.filesRowKey(group);
    if (!key) return '';
    return r.dataset[`${key}Name`] || '';
  }

  _setGlobalFile(group, obj) {
    const r = this.filesRow;
    if (!r) return;
    const key = window.MPE.groups.filesRowKey(group);
    if (!key) return;
    const url = (obj && obj.url) || '',
      name = (obj && obj.name) || '';
    if (url) r.dataset[`${key}Url`] = url;
    if (name) r.dataset[`${key}Name`] = name;
  }

  _bindFileInputs() {
    const self = this;
    this.querySelectorAll('input[type="file"][data-file]').forEach(input => {
      const group = (input.dataset.inputGroup || '').trim();
      const label = input.closest('label');
      const nameEl = label ? label.querySelector('.mpe-file-name') : null;
      const previewEl = label ? label.querySelector('.mpe-file-preview') : null;
      let lastUrl = '';

      function onChange() {
        const file = input.files && input.files[0];
        delete input.dataset.previewUrl;
        delete input.dataset.objectName;
        if (lastUrl) {
          try {
            URL.revokeObjectURL(lastUrl);
          } catch (e) {}
          lastUrl = '';
        }

        if (!file) {
          if (nameEl) nameEl.textContent = '';
          if (previewEl) {
            previewEl.style.display = 'none';
            previewEl.src = '';
          }
          return;
        }
        if (file.type.indexOf('image/') !== 0) {
          if (nameEl) nameEl.textContent = file.name + ' (unsupported)';
          if (previewEl) {
            previewEl.style.display = 'none';
            previewEl.src = '';
          }
          return;
        }
        let url = '';
        try {
          url = URL.createObjectURL(file);
        } catch (e) {
          url = '';
        }
        input.dataset.previewUrl = url;
        input.dataset.objectName = file.name;
        lastUrl = url;

        if (group && url) self._setGlobalFile(group, { url: url, name: file.name });
        if (nameEl) nameEl.textContent = file.name;
        if (previewEl) {
          previewEl.src = url;
          previewEl.style.display = 'inline-block';
        }
      }
      input.addEventListener('change', onChange, { passive: true });
    });
  }

  _prefillFilePreviewsFromGlobals() {
    const inputs = Array.from(
      this.querySelectorAll('input[type="file"][data-file]')
    );
    inputs.forEach(input => {
      const group = (input.dataset.inputGroup || '').trim();
      if (!group) return;
      const url = this._getGlobalFileUrl(group);
      const name = this._getGlobalFileName(group);
      if (!url) return;
      input.dataset.previewUrl = url;
      if (name) input.dataset.objectName = name;
      const label = input.closest('label');
      const nameEl = label ? label.querySelector('.mpe-file-name') : null;
      const previewEl = label ? label.querySelector('.mpe-file-preview') : null;
      if (nameEl && name) nameEl.textContent = name;
      if (previewEl) {
        previewEl.src = url;
        previewEl.style.display = 'inline-block';
      }
    });
  }

  // ---------- emit (із унікальним ключем включно з row_key) ----------
  _emitZonesContentNow() {
    const inputs = [];
    const seen = new Set();

    // активні зони для кожної групи
    const activeZoneByGroup = {};
    Object.keys(this.groups || {}).forEach(group => {
      const list = this.groups[group].filter(r => r.checked);
      if (list.length && !this._isGroupDisabled(group)) {
        const set = new Set();
        list.forEach(r => {
          const z = (r.dataset.radioZone || parseValue(r.value).zone || '').trim();
          if (z) set.add(z);
        });
        if (set.size) activeZoneByGroup[group] = set;
      }
    });

    const push = (obj) => {
      if (!obj || !obj.group || !obj.zone) return;
      const key = `${obj.row_key || 'r0'}:${obj.group}:${obj.zone}:${obj.type}`;
      if (seen.has(key)) return;
      seen.add(key);
      inputs.push(obj);
    };

    // збір із mpe-variant-table
    const rows = Array.from(
      this.querySelectorAll('.mpe-variant-table__row[data-row-index]')
    );
    rows.forEach(row => {
      const row_key = row.getAttribute('data-key') || '';
      row
        .querySelectorAll(
          '.mpe-variant-table__cell.is-visible [data-input-group]'
        )
        .forEach(el => {
          const group = (el.dataset.inputGroup || '').trim();
          if (!group || this._isGroupDisabled(group)) return;

          // зони: або явна, або всі активні групи
          let zonesToPush = [];
          const zone = (el.dataset.zone || '').trim();
          if (zone) zonesToPush = [zone];
          else {
            const set = activeZoneByGroup[group];
            if (set && set.size) zonesToPush = Array.from(set);
          }
          if (!zonesToPush.length) return;

          const tag = el.tagName.toLowerCase();
          const type = (tag === 'textarea')
            ? 'textarea'
            : (el.type || '').toLowerCase();
          if (type === 'hidden') return;

          zonesToPush.forEach(zx => {
            if (type === 'file') {
              const value =
                el.dataset.objectName ||
                (el.files && el.files[0] && el.files[0].name) ||
                '';
              const url =
                el.dataset.previewUrl || this._getGlobalFileUrl(group) || '';
              push({ row_key, group, zone: zx, value, type: 'file', url });
            } else if (type === 'checkbox') {
              push({
                row_key,
                group,
                zone: zx,
                value: el.checked ? '✓' : '',
                type: 'checkbox'
              });
            } else {
              const valueT = (el.value || '').trim();
              push({
                row_key,
                group,
                zone: zx,
                value: valueT,
                type: type === 'textarea' ? 'text' : type
              });
            }
          });
        });
    });

    // збір із mpe-variant-table__files-row
    const filesRow = this.querySelector('.mpe-variant-table__files-row');
    if (filesRow) {
      const row_key = filesRow.getAttribute('data-key') || '';
      filesRow
        .querySelectorAll(
          '.mpe-variant-table__cell.is-visible [data-input-group]'
        )
        .forEach(el => {
          const group = (el.dataset.inputGroup || '').trim();
          if (!group || this._isGroupDisabled(group)) return;

          const set = activeZoneByGroup[group];
          const zonesToPush = (el.dataset.zone || '').trim()
            ? [el.dataset.zone.trim()]
            : (set && set.size ? Array.from(set) : []);
          if (!zonesToPush.length) return;

          const tag = el.tagName.toLowerCase();
          const type = (tag === 'textarea')
            ? 'textarea'
            : (el.type || '').toLowerCase();
          if (type === 'hidden') return;

          zonesToPush.forEach(zx => {
            if (type === 'file') {
              const value =
                el.dataset.objectName ||
                (el.files && el.files[0] && el.files[0].name) ||
                '';
              const url =
                el.dataset.previewUrl || this._getGlobalFileUrl(group) || '';
              push({ row_key, group, zone: zx, value, type: 'file', url });
            } else if (type === 'checkbox') {
              push({
                row_key,
                group,
                zone: zx,
                value: el.checked ? '✓' : '',
                type: 'checkbox'
              });
            } else {
              const valueT = (el.value || '').trim();
              push({
                row_key,
                group,
                zone: zx,
                value: valueT,
                type: type === 'textarea' ? 'text' : type
              });
            }
          });
        });
    }

    document.dispatchEvent(
      new CustomEvent('mpe:zones:content', {
        detail: { inputs },
        bubbles: true,
        composed: true
      })
    );
  }

  _selectedGroups(activeByGroup) {
    return Array.from(activeByGroup.keys());
  }

  _appendFileProp(fd, idx, group, scope) {
    const prop = window.MPE.groups.formProp(group);
    if (!prop) return;
    const f = this._pickFileByGroup(scope, group);
    const url = this._pickUrlByGroup(scope, group) || 'empty';
    if (f) fd.append(`items[${idx}][properties][${prop}]`, f, f.name);
    else fd.append(`items[${idx}][properties][${prop}]`, url);
  }

  _collectTextValue(scope, group) {
    return this._pickTextByGroup(scope, group) || '';
  }

  // ---------- local DOM pickers ----------
  _isHttpUrl(v) {
    return !!(v && /^https?:\/\//i.test(String(v).trim()));
  }

  _pickFileByGroup(scope, group) {
    const vis =
      `.mpe-variant-table__files-row .mpe-variant-table__cell.is-visible ` +
      `input[type="file"][data-input-group="${group}"]`;
    const any = `input[type="file"][data-input-group="${group}"]`;
    const input = scope.querySelector(vis) || scope.querySelector(any);
    if (!input) return null;
    return (input.files && input.files.length) ? input.files[0] : null;
  }

  _pickUrlByGroup(scope, group) {
    const cellSel =
      `.mpe-variant-table__files-row .mpe-variant-table__cell.is-visible`;
    const filesRowEl =
      scope.querySelector('.mpe-variant-table__files-row') || null;

    // 1) видимий text/url/textarea інпут
    const visInput = scope.querySelector(
      `${cellSel} [data-input-group="${group}"]`
    );
    if (visInput) {
      const dpu = visInput.dataset?.previewUrl || '';
      if (this._isHttpUrl(dpu)) return dpu;

      const val = (visInput.value || '').trim();
      if (this._isHttpUrl(val)) return val;
    }

    // 2) видимий <input type="file">
    const fileVisible = scope.querySelector(
      `${cellSel} input[type="file"][data-input-group="${group}"]`
    );
    if (fileVisible) {
      const dpu = fileVisible.dataset?.previewUrl || '';
      if (this._isHttpUrl(dpu)) return dpu;
      const val = (fileVisible.value || '').trim();
      if (this._isHttpUrl(val)) return val;
    }

    // 3) фолбек з files-row (через реєстр груп)
    const key = window.MPE.groups.filesRowKey(group);
    if (filesRowEl && key) {
      const fromRow = filesRowEl.dataset[`${key}Url`] || '';
      if (this._isHttpUrl(fromRow)) return fromRow;
    }
    return '';
  }

  _pickTextByGroup(scope, group) {
    const sel =
      `.mpe-variant-table__cell.is-visible [data-input-group="${group}"]`;
    const el = scope.querySelector(sel);
    if (!el) return '';
    if (el.tagName.toLowerCase() === 'textarea')
      return (el.value || '').trim();
    const type = (el.type || '').toLowerCase();
    if (['text', 'search', 'tel', 'email', 'url'].includes(type))
      return (el.value || '').trim();
    return (el.value || '').trim();
  }
}

if (!customElements.get('mpe-print-toggle')) {
  customElements.define('mpe-print-toggle', MpePrintToggle);
}

document.addEventListener('shopify:section:load', e => {
  e.target.querySelectorAll('mpe-print-toggle').forEach(el => {
    if (el && typeof el.reinitialize === 'function') el.reinitialize();
  });
});


  // ---------- <p-editor-preview> ----------
  class PEditorPreview extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onRadiosChange = this.onRadiosChange.bind(this);
      this.currentSide = this.dataset.side || 'front';
      this.inputs = [];
      this._raf = 0;
    }
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.sideOrder = $$('[data-role="side-label"]', this).map(el => el.dataset.side);
      if (!this.sideOrder.length) {
        const set = new Set();
        $$('[data-side]', this).forEach(el => set.add(el.dataset.side));
        this.sideOrder = Array.from(set);
      }
      this.scope = this.closest('mpe-print-toggle') || document;
      this.radiosRoot = $('.print-radios', this.scope) || this.scope;
      if (this.radiosRoot) {
        this.radiosRoot.addEventListener('change', this.onRadiosChange, true);
        this.radiosRoot.addEventListener('click', this.onRadiosChange, true);
      }
      this._schedulePreviewRefresh();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.radiosRoot) {
        this.radiosRoot.removeEventListener('change', this.onRadiosChange, true);
        this.radiosRoot.removeEventListener('click', this.onRadiosChange, true);
      }
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    onRadiosChange() { this._schedulePreviewRefresh(); }
    _schedulePreviewRefresh() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => {
        this._raf = 0;
        this.updateFromRadios();
        this.renderAllSides();
        this.updateSide(this.currentSide);
      });
    }

    updateFromRadios() {
      const toggles = $$('input[data-radio-group]', this.radiosRoot)
        .filter(el => (el.type === 'checkbox' || el.type === 'radio') ? el.checked : false);

      const out = [];
      for (const t of toggles) {
        const group = (t.dataset.radioGroup || '').trim();
        const zone = (t.dataset.radioZone || '').trim();
        const side = (t.dataset.side || '').trim() || sideOf(zone);
        if (!group || !zone) continue;

        const isFile = window.MPE.groups.isFile(group);
        const type = isFile ? 'file' : 'text';

        
        let value = '';
        if (!isFile) {
          const col = this.querySelector(`[data-group="${group}"]`);
          const alias = col?.dataset?.groupPrintTemp || null;
          value = alias || window.MPE.groups.placeholder(group);
        }


        let url = '';
        if (isFile) url = this._pickUrlForGroup(group) || '';

        out.push({ group, zone, side, type, value, url });
      }
      this.inputs = out;
    }


    getAllSidesFromInputs() {
      const sides = new Set(this.inputs.map(i => sideOf(i.zone)));
      const order = (this.sideOrder && this.sideOrder.length) ? this.sideOrder : ['front', 'back', 'left', 'right'];
      return order.filter(s => sides.has(s));
    }
    renderAllSides() {
      const sides = this.getAllSidesFromInputs();
      if (!sides.length) {
        $$('.g-content .g-side .icon .zone-content', this).forEach(n => n.remove());
        $$('.g-content .g-side .icon', this).forEach(icon => icon.classList.add('is-hidden'));
        return;
      }
      sides.forEach(s => this.applyVisibilityForSide(s));
    }

    onClick(e) {
      const el = e.target.closest('[data-action]');
      if (!el) return;
      switch (el.dataset.action) {
        case 'side-prev': this.switchSide(-1); return;
        case 'side-next': this.switchSide(1); return;
      }
    }
    switchSide(step) {
      if (!this.sideOrder.length) return;
      const idx = Math.max(0, this.sideOrder.indexOf(this.currentSide));
      const next = (idx + step + this.sideOrder.length) % this.sideOrder.length;
      this.updateSide(this.sideOrder[next]);
    }
    updateSide(side) {
      this.currentSide = side;
      $$('.g-underlay .icon[data-side]', this).forEach(svg => svg.classList.toggle('is-hidden', svg.dataset.side !== side));
      $$('.g-content .g-side', this).forEach(g => g.classList.toggle('is-hidden', g.dataset.side !== side));
      $$('.p-editor-preview__card-controls .p-editor-preview__row[data-side]', this).forEach(r => r.classList.toggle('is-hidden', r.dataset.side !== side));
      $$('[data-role="side-label"]', this).forEach(lbl => lbl.classList.toggle('is-hidden', lbl.dataset.side !== side));
      this.applyVisibilityForSide(side);
    }

    applyVisibilityForSide(side) {
      const rel = this.inputs.filter(i => sideOf(i.zone) === side);
      const zones = new Set(rel.map(i => String(i.zone)));
      const groups = new Set(rel.map(i => String(i.group)));
      const sideGroup = $(`.g-content .g-side[data-side="${side}"]`, this);
      if (sideGroup) {
        $$('.icon[data-zone-id]', sideGroup).forEach(icon => {
          const zid = icon.getAttribute('data-zone-id') || '';
          icon.classList.toggle('is-hidden', !zones.has(zid));
          icon.querySelectorAll('.zone-content').forEach(n => n.remove());
        });
      }
      rel.forEach(item => this.renderZoneContent(item));
      const row = $(`.p-editor-preview__card-controls .p-editor-preview__row[data-side="${side}"]`, this);
      if (!row) return;
      $$('.p-editor-preview__col[data-group]', row).forEach(col => {
        col.classList.add('is-hidden');
        $$('[data-input-id]', col).forEach(tile => tile.classList.add('is-hidden'));
      });
      groups.forEach(group => {
        const col = $(`.p-editor-preview__col[data-group="${group}"]`, row);
        if (!col) return;
        col.classList.remove('is-hidden');
        rel.filter(i => i.group === group).forEach(i => {
        const id = `${i.group}|${i.zone}`;
        const tile = col.querySelector(`[data-input-id="${CSS.escape(id)}"]`);

          if (tile) tile.classList.remove('is-hidden');
        });
        const hasVisible = !!col.querySelector('[data-input-id]:not(.is-hidden)');
        if (!hasVisible) col.classList.add('is-hidden');
      });
    }

renderZoneContent(item) {
  const { group, zone, value, type, url } = item || {};
  if (!group || !zone) return;
  const icon = this.querySelector(`.g-content .g-side[data-side="${sideOf(zone)}"] .icon[data-zone-id="${zone}"]`);
  if (!icon) return;

  const kind = (group === 'nummer') ? 'number' : (type === 'file' ? 'image' : 'text');
  const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  g.setAttribute('class', `zone-content zone-content--${group}`);

  if (type === 'file') {
    if (!url) { icon.appendChild(g); return; }

    const Z = measureZone(zone);
    if (!Z) { icon.appendChild(g); return; }

    const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    img.setAttribute('href', url);
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', url);
    img.setAttribute('crossorigin', 'anonymous'); // важливо

    img.setAttribute('x', String(Z.x));
    img.setAttribute('y', String(Z.y));
    img.setAttribute('width', String(Z.w));
    img.setAttribute('height', String(Z.h));
    img.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    img.setAttribute('class', `zone-image zone-image--${group}`);

    g.appendChild(img);
    icon.appendChild(g);
    return;
  }

  const textVal = (value && String(value).trim()) || PLACEHOLDERS[group] || '';
  const Mfit = fitTextToZone(textVal, zone, kind);
  if (!Mfit) { icon.appendChild(g); return; }

  const { font, lines, lineHeightEm } = Mfit;
  const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  t.setAttribute('x', String(Mfit.cx));
  t.setAttribute('y', String(Mfit.cy));
  t.setAttribute('text-anchor', 'middle');
  t.setAttribute('dominant-baseline', 'middle');
  t.setAttribute('font-size', String(font));
  t.setAttribute('class', `zone-text zone-text--${group}`);

  const firstDy = lines.length > 1 ? -((lines.length - 1) * lineHeightEm * font / 2) : 0;
  const t1 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
  t1.setAttribute('x', String(Mfit.cx));
  t1.setAttribute('dy', String(firstDy));
  t1.textContent = lines[0] || '';
  t.appendChild(t1);

  if (lines.length > 1) {
    const t2 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
    t2.setAttribute('x', String(Mfit.cx));
    t2.setAttribute('dy', String(lineHeightEm * font));
    t2.textContent = lines[1] || '';
    t.appendChild(t2);
  }
  g.appendChild(t);
  icon.appendChild(g);
}


    async generatePreviewDataURL({ side = this.currentSide, type = 'image/png', quality } = {}) {
      const svgEl = this.querySelector('.p-editor-preview__preview');
      if (!svgEl) return null;
      const prevSide = this.currentSide;
      this.updateSide(side);
      const serializer = new XMLSerializer();
      const svgText = serializer.serializeToString(svgEl);
      const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
      const svgUrl = URL.createObjectURL(svgBlob);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      const dataURL = await new Promise(res => {
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const vb = (svgEl.getAttribute('viewBox') || '0 0 460 480').split(/\s+/).map(Number);
          const w = vb[2] || 460;
          const h = vb[3] || 480;
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          try { res(canvas.toDataURL(type, quality)); }
          catch { res(canvas.toDataURL('image/png')); }
          finally { URL.revokeObjectURL(svgUrl); }
        };
        img.onerror = () => { URL.revokeObjectURL(svgUrl); res(null); };
        img.src = svgUrl;
      });
      this.updateSide(prevSide);
      return dataURL;
    }
    _pickFilesRowUrl(group) {
      const scope = this.closest('mpe-print-toggle') || document;
      const r = scope.querySelector('.mpe-variant-table__files-row');
      if (!r) return '';
      const key = window.MPE.groups.filesRowKey(group);
      if (!key) return '';
      return r.dataset[`${key}Url`] || '';
    }

    // замість прямого serializeToString(svgEl)
    async generatePreviewBlob({ type = 'image/png' } = {}) {
      const svgEl = this.querySelector('.p-editor-preview__preview');
      if (!svgEl) return null;
      const { svgString, width, height } = await window.MPE.preview.prepareExportSvg(svgEl);
      const Canvg = window.MPE.deps.requireCanvg?.();
      const outW = width, outH = height;
      if (Canvg) {
        const canvas = document.createElement('canvas');
        canvas.width = outW; canvas.height = outH;
        const ctx = canvas.getContext('2d');
        const v = await Canvg.from(ctx, svgString, { enableRedraw: false, ignoreMouse: true, ignoreAnimation: true, useCORS: true });
        await v.render();
        return await new Promise(r => canvas.toBlob(b => r(b), 'image/png'));
      }
      // <img> fallback
      const blobSvg = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(blobSvg);
      try {
        const img = new Image(); img.crossOrigin = 'anonymous';
        await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = url; });
        const canvas = document.createElement('canvas');
        canvas.width = outW; canvas.height = outH;
        canvas.getContext('2d').drawImage(img, 0, 0, outW, outH);
        return await new Promise(r => canvas.toBlob(b => r(b), 'image/png'));
      } finally { URL.revokeObjectURL(url); }
    }
    // pick URL from <p-editor-preview data-*> else from files-row
    _pickUrlForGroup(group) {
      const key = window.MPE.groups.filesRowKey(group);
      const ds = this.dataset || {};
      if (key) {
        // expect data-logo2-url / data-logo-url / data-sponsor-url etc.
        const camel = `${key}Url`; // у dataset воно camelCase за правилом data-foo-bar -> dataset.fooBar
        // перетворимо dashed key в camelCase, якщо потрібно
        const toCamel = (s) => s.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
        const prop = toCamel(camel);
        if (ds[prop]) return ds[prop];
      }
      return this._pickFilesRowUrl(group) || '';
    }



  }
  if (!customElements.get('p-editor-preview')) customElements.define('p-editor-preview', PEditorPreview);

  // ---------- Formatter (events) ----------
  (() => {
    const formatByTarget = new Map();
    const num = (v) => Number.parseFloat(v || '0') || 0;
    const ensureBase = (el, map) => {
      for (const [attr, key] of Object.entries(map)) {
        if (!el.hasAttribute(key)) {
          const v = el.getAttribute(attr);
          if (v != null) el.setAttribute(key, v);
        }
      }
    };
    const parseTarget = (t = '') => {
      // 1) новий формат group|zone
      const pipe = t.indexOf('|');
      if (pipe >= 0) return { group: t.slice(0, pipe), zone: t.slice(pipe + 1) };

      // 2) fallback: старий формат group-zone → ріжемо по останньому дефісу
      const i = t.lastIndexOf('-');
      if (i < 0) return { group: t, zone: '' };
      return { group: t.slice(0, i), zone: t.slice(i + 1) };
    };

    const applyToText = (textEl, fmt) => {
      if (!textEl) return;
      ensureBase(textEl, { 'font-size': 'data-base-font-size' });
      if (fmt.textColor) textEl.setAttribute('fill', fmt.textColor);
      if (fmt.fontFamily) textEl.setAttribute('font-family', fmt.fontFamily);
      if (fmt.fontFamily) textEl.querySelector('tspan').setAttribute('style', `font-family: ${fmt.fontFamily};`);
      if (fmt.fontWeight) textEl.setAttribute('font-weight', String(fmt.fontWeight));
      const base = num(textEl.getAttribute('data-base-font-size'));
      const scale = fmt.textScale || 1;
      if (base > 0) textEl.setAttribute('font-size', String(base * scale));
    };
    const applyToImage = (imgEl, fmt) => {
      if (!imgEl) return;
      if (!fmt._imageTouched) return;
      ensureBase(imgEl, { 'x': 'data-base-x', 'y': 'data-base-y', 'width': 'data-base-width', 'height': 'data-base-height' });
      if (!imgEl.hasAttribute('data-base-width') || !imgEl.hasAttribute('data-base-height')) {
        imgEl.setAttribute('data-base-x', imgEl.getAttribute('x') || '0');
        imgEl.setAttribute('data-base-y', imgEl.getAttribute('y') || '0');
        imgEl.setAttribute('data-base-width', imgEl.getAttribute('width') || '0');
        imgEl.setAttribute('data-base-height', imgEl.getAttribute('height') || '0');
      }
      const bx = num(imgEl.getAttribute('data-base-x'));
      const by = num(imgEl.getAttribute('data-base-y'));
      const bw = num(imgEl.getAttribute('data-base-width'));
      const bh = num(imgEl.getAttribute('data-base-height'));
      const s = fmt.imageScale || 1;
      const nw = bw * s, nh = bh * s;
      const cx = bx + bw / 2, cy = by + bh / 2;
      imgEl.setAttribute('width', String(nw));
      imgEl.setAttribute('height', String(nh));
      imgEl.setAttribute('x', String(cx - nw / 2));
      imgEl.setAttribute('y', String(cy - nh / 2));
    };
    const applyForTarget = (target, fmt) => {
      const { group, zone } = parseTarget(target);
      if (!zone || !group) return;
      const icons = $$('.g-content .icon[data-zone-id="' + CSS.escape(zone) + '"]');
      icons.forEach(icon => {
        const wrap = icon.querySelector('.zone-content.zone-content--' + group);
        if (!wrap) return;
        const textEl = wrap.querySelector('text');
        const imgEl = wrap.querySelector('image');
        if (textEl) applyToText(textEl, fmt);
        if (imgEl) applyToImage(imgEl, fmt);
      });
    };
    const reapplyAll = () => {
      for (const [target, fmt] of formatByTarget.entries()) applyForTarget(target, fmt);
    };
    document.addEventListener('mpe:format:update', (e) => {
      const { targets = [], format = {}, flags = {}, force = false } = e.detail || {};
      targets.forEach(t => {
        const prev = formatByTarget.get(t) || {};
        const next = { ...prev, ...format };
        if (flags && typeof flags.imageTouched === 'boolean') next._imageTouched = flags.imageTouched;
        formatByTarget.set(t, next);
        applyForTarget(t, next);
      });
      if (force) reapplyAll();
    });
    document.addEventListener('mpe:zones:content', () => reapplyAll());
  })();

  // ============================================================================
  // <p-editor-tools> — unified zone selector + formatting controls
  // ============================================================================
  class PEditorTools extends HTMLElement {
    connectedCallback() {
      this.classList.add('p-editor-tools');
      this._state = {
        textColor: '#000000',
        textScale: 1,
        fontFamily: 'Montserrat',
        fontWeight: 400,
        imageScale: 1,
        imageTouched: false
      };
      this._bind();
      this._initZoneSelector();
      this._observeGrid();
      this._emit();

      // слухаємо оновлення зон з Preview
      this._onZonesContent = () => {
        const grid = this._zonesGrid();
        const zs = grid?.__zoneSelector;
        zs?._ensureValidChecked();
        this._emit();
      };
      document.addEventListener('mpe:zones:content', this._onZonesContent);
    }

    disconnectedCallback() {
      document.removeEventListener('mpe:zones:content', this._onZonesContent);
      this._mo?.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    // ---------------------- UI Binds ---------------------------------------
    _bind() {
      this.addEventListener('click', (e) => {
        const sw = e.target.closest('.pet-swatch');
        if (sw) {
          const hex = sw.dataset.color;
          if (!hex) return;
          this._state.textColor = hex;
          $$('.pet-swatch', this).forEach(x => x.removeAttribute('aria-pressed'));
          sw.setAttribute('aria-pressed', 'true');
          this._emit();
          return;
        }

        const txt = e.target.closest('[data-text-scale]');
        if (txt) {
          this._state.textScale = Number(txt.dataset.textScale) || 1;
          const wrap = txt.parentElement;
          $$('[data-text-scale]', wrap).forEach(x => x.classList.remove('is-active'));
          txt.classList.add('is-active');
          this._emit();
          return;
        }

        const img = e.target.closest('[data-image-scale]');
        if (img) {
          this._state.imageScale = Number(img.dataset.imageScale) || 1;
          this._state.imageTouched = true;
          const wrap = img.parentElement;
          $$('[data-image-scale]', wrap).forEach(x => x.classList.remove('is-active'));
          img.classList.add('is-active');
          this._emit();
          return;
        }
      });

      const sel = $('.pet-fonts__select', this);
      sel?.addEventListener('change', () => {
        this._state.fontFamily = sel.value || 'Montserrat';
        this._emit();
      });

      const chk = $('.pet-bold__chk', this);
      chk?.addEventListener('change', () => {
        this._state.fontWeight = chk.checked ? 700 : 400;
        this._emit();
      });
    }

    // ---------------------- Zone Grid Utils --------------------------------
    _zonesGrid() {
      const acc = this.closest('.accordion__content');
      return acc ? $('.p-editor-preview__zones-grid', acc) : null;
    }

    _getVisibleTargets() {
      const grid = this._zonesGrid();
      if (!grid) return [];
      const checked = grid.querySelector('input[type=radio]:checked');
      if (checked) return [checked.dataset.inputId].filter(Boolean);
      return [];
    }

    // ---------------------- Observer ---------------------------------------
    _observeGrid() {
      const grid = this._zonesGrid();
      if (!grid) return;
      this._mo = new MutationObserver(() => {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this._emit());
      });
      this._mo.observe(grid, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    // ---------------------- Emit Event -------------------------------------
    _emit(force = false) {
      const { imageTouched, ...format } = this._state;
      const detail = {
        targets: this._getVisibleTargets(),
        format,
        flags: { imageTouched },
        force
      };
      const ev = new CustomEvent('mpe:format:update', { detail, bubbles: true });
      this.dispatchEvent(ev);
    }

    // ---------------------- Internal Zone Selector -------------------------
    _initZoneSelector() {
      const grid = this._zonesGrid();
      if (!grid) return;
      if (!grid.__zoneSelector)
        grid.__zoneSelector = new this._ZoneSelector(grid, () => this._emit());
    }

    // -----------------------------------------------------------------------
    // Inner class: _ZoneSelector
    // -----------------------------------------------------------------------
    _ZoneSelector = class {
      constructor(grid, onChange) {
        this.grid = grid;
        this.onChange = onChange;
        this.radios = $$('input[type="radio"][name^="zone-select-"]', grid);
        this.labels = $$('.p-editor-preview__input-id', grid);
        this._bind();
        this._ensureInitial();
        this._syncUI();
      }

      _bind() {
        this.grid.addEventListener('change', () => this._onChange());
        this.grid.addEventListener('click', (e) => this._onClickLabel(e));
      }

      _onClickLabel(e) {
        const label = e.target.closest('.p-editor-preview__input-id');
        if (!label) return;
        const input = label.querySelector('input[type="radio"]');
        if (!input) return;
        if (!input.checked) {
          input.checked = true;
          this._onChange();
        }
      }

      _onChange() {
        this._syncUI();
        this.grid.classList.toggle('___tick');
        this.grid.classList.toggle('___tick');
        this.onChange?.();
      }

      _ensureInitial() {
        const anyChecked = this.radios.some(r => r.checked);
        if (anyChecked) return;
        const firstVisible = this.labels.find(l => !l.classList.contains('is-hidden'))
          ?.querySelector('input[type="radio"]');
        if (firstVisible) firstVisible.checked = true;
        else if (this.radios[0]) this.radios[0].checked = true;
      }

      _ensureValidChecked() {
        const isVisible = (lab) => !lab.classList.contains('is-hidden');
        const checkedRadio = this.radios.find(r => r.checked);
        const checkedLabel = checkedRadio?.closest('.p-editor-preview__input-id') || null;
        if (checkedLabel && isVisible(checkedLabel)) return;

        const firstVisibleLabel = this.labels.find(isVisible);
        const firstVisibleRadio = firstVisibleLabel?.querySelector('input[type="radio"]') || null;
        if (firstVisibleRadio && !firstVisibleRadio.checked) {
          firstVisibleRadio.checked = true;
          this._onChange();
        }
      }

      _syncUI() {
        const checked = this.radios.find(r => r.checked);
        const activeId = checked ? checked.dataset.inputId : null;
        this.labels.forEach(lab => {
          const r = lab.querySelector('input[type="radio"]');
          const isActive = r && r.dataset.inputId === activeId;
          lab.classList.toggle('is-active', !!isActive);
          // не чіпаємо .is-hidden — це керується PEditorPreview.applyVisibilityForSide
          if (r) r.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
        this._ensureValidChecked();
      }
    };
  }

  if (!customElements.get('p-editor-tools'))
    customElements.define('p-editor-tools', PEditorTools);




  // ---------- <p-editor-preview-actions> ----------
  class PEditorPreviewActions extends HTMLElement {
    connectedCallback() {
      this.classList.add('p-editor-preview-actions');
      this.addEventListener('click', this._onClick);
    }
    disconnectedCallback() { this.removeEventListener('click', this._onClick); }
_onClick = (e) => {
  const btn = e.target.closest('[data-action]'); if (!btn) return;
  const action = btn.dataset.action;
  const setBusy = (b) => { btn.disabled = b; btn.dataset.loading = b ? '1' : ''; };

  const run = async () => {
    setBusy(true);
    try {
      await deps?.waitForLibs?.();
      const previewSvg = PrevUtil.getPreviewSvg
        ? PrevUtil.getPreviewSvg()
        : (document.querySelector('p-editor-preview')?.querySelector('.p-editor-preview__preview') || null);
      if (!previewSvg) return;

      const { svgString, width, height } = (PrevUtil.prepareExportSvg
        ? await PrevUtil.prepareExportSvg(previewSvg)
        : await (async () => {
            const built = (SVGUtil.buildCombinedSVG ? SVGUtil.buildCombinedSVG(previewSvg, { includeUnderlay: true }) : null);
            if (!built) return { svgString: '', width: 0, height: 0 };
            await (SVGUtil.inlineExternalUses ? SVGUtil.inlineExternalUses(built.svg) : Promise.resolve());
            await (SVGUtil.inlineImagesToData ? SVGUtil.inlineImagesToData(built.svg, { strict: true, placeholder: true }) : Promise.resolve());
            const xml = new XMLSerializer().serializeToString(built.svg);
            return { svgString: xml, width: built.width, height: built.height };
          })());
console.log('[DEBUG] SVG Preview:', svgString.slice(0, 800));

      const renderToCanvas = async (scale) => {
        const Canvg = deps.requireCanvg();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        const v = await Canvg.from(ctx, svgString, {
          enableRedraw: false, ignoreMouse: true, ignoreAnimation: true, useCORS: true
        });
        await v.render();
        return canvas;
      };

      if (action === 'download-png') {
        const canvas = await renderToCanvas(2); // стабільний 2x
        await new Promise(r => canvas.toBlob(b => {
          if (b) {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(b);
            a.download = 'design-all.png';
            a.click();
            URL.revokeObjectURL(a.href);
          }
          r();
        }, 'image/png'));
      }

      if (action === 'download-pdf') {
        const jsPDF = deps.requireJsPDF();
        const canvas2x = await renderToCanvas(2);
        const targetBytes = 1_000_000;

        const downscaleToTarget = async (canvas) => {
          const tryEncode = async (cnv, q) => await new Promise(r => cnv.toBlob(b => r(b), 'image/jpeg', q));
          let cur = canvas, quality = 0.82;
          let blob = await tryEncode(cur, quality);
          if (blob && blob.size <= targetBytes) return blob;

          for (let i = 0; i < 6; i++) {
            if (blob && blob.size <= targetBytes) break;
            if (quality > 0.5) {
              quality = Math.max(0.5, quality - 0.08);
            } else {
              const s = 0.88;
              const c2 = document.createElement('canvas');
              c2.width = Math.round(cur.width * s);
              c2.height = Math.round(cur.height * s);
              c2.getContext('2d').drawImage(cur, 0, 0, c2.width, c2.height);
              cur = c2;
            }
            blob = await tryEncode(cur, quality);
          }
          return blob || await tryEncode(cur || canvas, 0.7);
        };

        const jpegBlob = await downscaleToTarget(canvas2x);
        const jpegUrl = URL.createObjectURL(jpegBlob);
        try {
          const pdf = new jsPDF({
            orientation: width > height ? 'landscape' : 'portrait',
            unit: 'pt',
            format: 'a4',
            compress: true
          });
          const pageW = pdf.internal.pageSize.getWidth();
          const pageH = pdf.internal.pageSize.getHeight();
          const margin = 24;
          const ratio = Math.min((pageW - 2 * margin) / width, (pageH - 2 * margin) / height);
          const drawW = width * ratio, drawH = height * ratio;
          const offX = (pageW - drawW) / 2, offY = (pageH - drawH) / 2;

          const img = new Image(); img.src = jpegUrl;
          await new Promise((res, rej) => { img.onload = res; img.onerror = rej; });

          pdf.addImage(img, 'JPEG', offX, offY, drawW, drawH, undefined, 'FAST');
          pdf.save('design-all.pdf');
        } finally {
          URL.revokeObjectURL(jpegUrl);
        }
      }
    } finally {
      setBusy(false);
    }
  };

  run();
}

  }
  if (!customElements.get('p-editor-preview-actions')) customElements.define('p-editor-preview-actions', PEditorPreviewActions);



  // ---------- <mpe-order-totals> ----------
  class MpeOrderTotals extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('mpe-print-toggle') || document;
      this.host = $('[data-role="totals"]', this.scope) || $('.mpe-variant-table__total', this.scope);
      this.radiosRoot = $('.print-radios', this.scope) || this.scope;
      this._onAnyChange = this._onAnyChange?.bind ? this._onAnyChange.bind(this) : (e) => this._onAnyChange(e);
      if (this.radiosRoot) this.radiosRoot.addEventListener('change', this._onAnyChange);
      document.addEventListener('mpe:zones:content', this._onAnyChange);
      this.recalcAndRender();
    }
    disconnectedCallback() {
      if (this.radiosRoot) this.radiosRoot.removeEventListener('change', this._onAnyChange);
      document.removeEventListener('mpe:zones:content', this._onAnyChange);
    }
    _onAnyChange() { clearTimeout(this._t); this._t = setTimeout(() => this.recalcAndRender(), 0); }
    recalcAndRender() {
      if (!this.host) return;
      const rowsCount = $$('.mpe-variant-table__row[data-row-index]', this.scope).length;
      const picked = $$('input[data-radio-group][type="checkbox"]:checked, input[data-radio-group][type="radio"]:checked', this.radiosRoot);
      const buckets = new Map();
      for (const el of picked) {
        const handle = (el.dataset.productHandle || el.dataset.printHandle || '').trim();
        const title = (el.dataset.productTitle || handle || 'Service').trim();
        const priceCents = this._toCents(el.dataset.productPrice);
        if (!buckets.has(handle)) buckets.set(handle, { handle, title, unit_price_cents: priceCents, quantity: 0, total_price_cents: 0 });
        const b = buckets.get(handle);
        const qtyAdd = rowsCount || 0;
        b.quantity += qtyAdd;
        if (priceCents != null) b.total_price_cents += priceCents * qtyAdd; else b.total_price_cents = null;
        if (b.unit_price_cents == null && priceCents != null) b.unit_price_cents = priceCents;
        if (!b.title && title) b.title = title;
      }
      const grouped = Array.from(buckets.values());
      this._render(grouped);
    }
    _toCents(v) { if (v == null || v === '') return null; const n = Number(v); return Number.isFinite(n) ? Math.round(n) : null; }
    _fmt(cents) { if (cents == null) return '—'; const euros = (cents / 100).toFixed(2); return euros.replace('.', ',') + ' €'; }
    _render(grouped) {
      this.host.innerHTML = '';
      const tpl = $('#mpe-totals-tpl', document);
      const rowT = $('#mpe-totals-row-tpl', document);
      if (!tpl || !rowT) return;
      const root = tpl.content ? tpl.content.cloneNode(true) : document.importNode(tpl, true);
      const tbody = root.querySelector('[data-role="body"]');
      const grandCell = root.querySelector('[data-role="grand"]');
      let grand = 0, haveAnyPrice = false;
      grouped.forEach(g => {
        const row = rowT.content ? rowT.content.cloneNode(true) : document.importNode(rowT, true);
        const rTitle = row.querySelector('[data-role="title"]');
        const rHandle = row.querySelector('[data-role="handle"]');
        const rQty = row.querySelector('[data-role="qty"]');
        const rUnit = row.querySelector('[data-role="unit"]');
        const rSum = row.querySelector('[data-role="sum"]');
        if (rTitle) rTitle.textContent = g.title || 'Service';
        if (rHandle) rHandle.textContent = g.handle ? `(${g.handle})` : '';
        if (rQty) rQty.textContent = String(g.quantity);
        if (rUnit) rUnit.textContent = this._fmt(g.unit_price_cents);
        if (rSum) rSum.textContent = this._fmt(g.total_price_cents);

        if (g.total_price_cents != null) { grand += g.total_price_cents; haveAnyPrice = true; }
        tbody && tbody.appendChild(row);
      });
      if (grandCell) grandCell.textContent = haveAnyPrice ? this._fmt(grand) : '—';
      this.host.appendChild(root);
    }
  }
  if (!customElements.get('mpe-order-totals')) customElements.define('mpe-order-totals', MpeOrderTotals);
  document.addEventListener('shopify:section:load', (e) => {
    const scope = e.target;
    const els = scope.querySelectorAll('mpe-order-totals');
    els.forEach(el => el.connectedCallback && el.connectedCallback());
  });

  // ---------- expose ----------
  Object.assign(window.MPE, {
    MpePrintToggle, PEditorPreview, PEditorTools, PEditorPreviewActions, MpeOrderTotals
  });
})();
